import { Box, TextField, Typography, Paper } from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import FloatingSearchBar from "../../../../components/FloatingSearchBar/FloatingSearchBar";
import ConfigurableTabs from "../../../../components/Tabs/Tabs";
import useSave from "../../../../Hooks/useSave";
import { useNavigate, useParams } from "react-router-dom";
import Divider from "@mui/material/Divider";
import AddIcon from "@mui/icons-material/Add";
import { Button, IconButton, Input, Tooltip } from "@mui/material";
import { FormControlLabel } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Autocomplete from "@mui/material/Autocomplete";
import BasicTable from "../../../../components/InfoDisplay/InfoDisplay";
import Switch from "@mui/material/Switch";

export default function NewOrderCustomer() {
  const { fetchGraphql, DialogSave } = useSave();
  const navigate = useNavigate();
  const [searchField, setSearchField] = useState("");
  const { id } = useParams();
  const [stillTypeing, setStillTypeing] = useState(false);
  const timeout = {};

  //create date
  const date = new Date();
  const est1 = new Date(date.getTime() + -240 * 60 * 1000);
  const tomorow = new Date(est1);
  tomorow.setDate(date.getDate() + 1);

  const [customersOptions, setCustomersOptions] = useState([]);
  const [order, setOrder] = useState({
    deliveryDate: tomorow,
  });
  const [products, setProducts] = useState([]);

  function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  function handleOnChange(e) {
    setSearchField(e.target.value);
  }

  useEffect(() => {
    fetchGraphql({
      query: `query Customers {
        customers {
          customerName
          customerId
        }
      }`,
    }).then((result) =>
      setCustomersOptions(
        result.data.customers.map((item) => ({
          ...item,
          label: item.customerName,
        }))
      )
    );

    return () => {};
  }, []);

  useEffect(() => {
    fetchGraphql({
      query: `query Products {
        products {
          productId
          productCode
          productName
          productDescription
          productPrice
          productCategory
          productSubCategory
          productUnitOfMeasure
          productAmount
          groupId
          groupCode
          productType
          priceByPound
        }
      }`,
    }).then((result) => setProducts(result.data.products));

    return () => {};
  }, []);

  function saveOrder(order) {
    fetchGraphql({
      query: `mutation UpdateOrder($orderId: ID!, $order: orderInput) {
        updateOrder(orderId: $orderId, order: $order) {
          customerId
          deliveryDate
          orderNote
        }
      }`,
      variables: { orderId: id, order },
    }).then((result) => setOrder(result.data.updateOrder));
  }

  async function saveOrderProduct(orderProduct, orderProductId) {
    // console.log(orderProductId);
    const result = orderProductId
      ? await fetchGraphql({
          query: `mutation UpdateOrderProduct($orderProductId: ID, $product: orderProductInput) {
            updateOrderProduct(orderProductId: $orderProductId, product: $product) {
              orderProductId
              orderId
              productId
              productCode
              productName
              productPrice
              quantity
              priceByPound
            }
          }`,
          variables: { orderProductId, product: orderProduct },
        })
      : await fetchGraphql({
          query: `mutation CreateOrderProduct($orderId: ID, $product: orderProductInput) {
            createOrderProduct(orderId: $orderId, product: $product)
          }`,
          variables: { orderId: id, product: orderProduct },
        });

    return await Promise.resolve(result.data);
  }

  function typeing(save) {
    clearTimeout(stillTypeing);

    setStillTypeing(setTimeout(() => save(), 3000));
  }

  function updateOrder(order) {
    typeing(() => saveOrder(order));
  }

  const tabs = products
    ?.filter(
      (item) =>
        item.productName.toLowerCase().includes(searchField.toLowerCase()) ||
        item.productCode.toLowerCase().includes(searchField.toLowerCase())
    )
    ?.map((item) => item.productCategory)
    .filter(
      (value, index, self) => value !== null && onlyUnique(value, index, self)
    )
    .sort((a, b) => a.localeCompare(b))
    .map((item1) => ({
      label: item1 === "" ? "Uncategorized" : item1,
      content: (
        <Paper sx={{ margin: "10px auto", maxWidth: "800px" }} elevation="6">
          <Typography
            sx={{
              // borderBottom: "solid 2px rgb(0,0,0,.4)",
              textAlign: "center",
              fontStyle: "italic",
              padding: "20px",
            }}
            fontSize={30}
          >
            {item1 === "" ? "Uncategorized" : item1}
          </Typography>
          {products
            ?.filter((item) => item.productCategory === item1)
            .filter(
              (item) =>
                item.productName
                  .toLowerCase()
                  .includes(searchField.toLowerCase()) ||
                item.productCode
                  .toLowerCase()
                  .includes(searchField.toLowerCase())
            )
            .map((item, index) => (
              <Box
                sx={{
                  backgroundColor: `${
                    Number.isInteger(index / 2) ? "#f2f2f2" : ""
                  }`,
                  padding: "5px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography sx={{ marginLeft: "10px" }} fontSize={16}>
                  {item.productCode + " - " + item.productName}
                </Typography>

                <TextField
                  type="number"
                  size="small"
                  sx={{ margin: "10px", marginLeft: "auto" }}
                  value={item.quantity}
                  onChange={(e) => {
                    const copyState = [...products];

                    const row = copyState.find(
                      (row) => row.productId === item.productId
                    );

                    row.quantity = parseInt(e.target.value) || null;

                    // console.log("row.orderProductId", row.orderProductId);

                    setProducts(copyState);

                    typeing(() =>
                      saveOrderProduct(
                        {
                          quantity: parseInt(e.target.value) || null,
                          productId: row.productId,
                        },
                        row.orderProductId
                      ).then((result) => {
                        // console.log(result);
                        if (result.createOrderProduct)
                          row.orderProductId = result.createOrderProduct;
                        if (result.updateOrderProduct)
                          row.quantity = result.updateOrderProduct.quantity;

                        // console.log(row);

                        setProducts(copyState);
                      })
                    );
                  }}
                />
              </Box>
            ))}
        </Paper>
      ),
    }));

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        overflow: "hidden",
      }}
    >
      <DialogSave />

      <FloatingSearchBar value={searchField} onChange={handleOnChange} />

      <Box sx={{ display: "flex", flexDirection: "column", marginTop: "50px" }}>
        <Autocomplete
          disablePortal
          autoSelect={true}
          autoHighlight={true}
          options={customersOptions}
          onChange={(event, value) => {
            setOrder({
              ...order,
              customerId: value.customerId,
            });

            updateOrder({
              ...order,
              customerId: value.customerId,
            });
          }}
          sx={{ width: 250, marginRight: "10px" }}
          renderInput={(params) => (
            <TextField {...params} label="Customer Name" />
          )}
        />

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            margin: "10px 10px 10px 0px",
          }}
        >
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
              label="Delivery Date"
              openTo="day"
              views={["year", "month", "day"]}
              shouldDisableDate={(date) => {
                const today = new Date();
                const todayDate = new Date(date);

                if (date < today.setDate(today.getDate())) return true;

                if (todayDate.getDay() === 6) return true;
              }}
              value={order.deliveryDate || tomorow}
              onChange={(newValue) => {
                setOrder({
                  ...order,
                  deliveryDate: newValue._d,
                });

                updateOrder({
                  ...order,
                  deliveryDate: newValue._d,
                });
              }}
              onBlur={(newValue) => {
                clearTimeout(stillTypeing);

                saveOrder({
                  ...order,
                  deliveryDate: newValue._d,
                });
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </Box>

        <TextField
          sx={{ width: "250px" }}
          multiline
          onChange={(e) => {
            setOrder({
              ...order,
              orderNote: e.target.value,
            });

            updateOrder({
              ...order,
              orderNote: e.target.value,
            });
          }}
          onBlur={(e) => {
            clearTimeout(stillTypeing);

            saveOrder({
              ...order,
              orderNote: e.target.value,
            });
          }}
          label="Order Note"
          value={order.orderNote || null}
          color="primary"
        />

        <Button
          sx={{ margin: "10px 10px 10px 0px" }}
          variant="contained"
          onClick={() => {
            fetchGraphql({
              query: `mutation CreateOrder($order: orderInput, $products: [orderProductInput]) {
                createOrder(order: $order, products: $products)
              }`,
              variables: {
                products: products.map((item) => ({
                  productId: item.productId,
                  quantity: item.quantity,
                })),
                order,
              },
            }).then((result) =>
              navigate(`/orders/order/${result.data.createOrder}/order`)
            );
          }}
        >
          Submit order
        </Button>
      </Box>

      <ConfigurableTabs tabs={tabs} />
    </Box>
  );
}
